import { cn } from '@/lib/utils';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Card, CardContent } from '@/components/ui/card';

const PreviewCard = ({ profileData, generatedMessage }) => {
  const { profile_name, username, biography } = profileData || {};

  return (
    <Card className='relative h-full transition-all duration-300 ease-in-out hover:shadow-md'>
      <CardContent className='relative flex h-full flex-col p-3'>
        {/* Profile Section - Top */}
        <div className='mb-3 flex items-center gap-3'>
          <Avatar className='h-10 w-10'>
            <AvatarImage />
            <AvatarFallback>
              {profile_name?.charAt(0).toUpperCase() ||
                username?.charAt(0).toUpperCase() ||
                ''}
            </AvatarFallback>
          </Avatar>

          <div className='min-w-0 flex-1'>
            <div className='flex items-center justify-between'>
              <div className='min-w-0 flex-1'>
                <h3 className='max-w-72 truncate text-sm font-semibold'>
                  {profile_name || 'Unknown'}
                </h3>
                <div className='mt-1 flex items-center gap-1 text-xs text-muted-foreground'>
                  <a
                    href={`https://instagram.com/${username}`}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-primary transition-colors hover:underline'
                  >
                    @{username || 'username'}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bio Section */}
        {biography && (
          <div className='mb-3'>
            <p className='line-clamp-3 text-xs text-muted-foreground'>
              {biography}
            </p>
          </div>
        )}

        {/* Message Section - Bottom */}
        <div className='mb-3 mt-auto'>
          <div
            className={cn(
              'relative min-h-[250px] rounded-lg bg-muted/50 p-3',
              'whitespace-pre-wrap border border-muted-foreground/20'
            )}
          >
            <p className='text-xs leading-normal text-foreground'>
              {generatedMessage || 'No message available'}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PreviewCard;
